import { WithLayoutProps } from './PageLoader';
import { PageLoaderHeader } from './PageLoaderHeader';
import { FullPageLayout } from 'src/components/layouts';

type PageLoaderLayoutProps = Omit<
  WithLayoutProps,
  'productTitle' | 'withLayout'
> & {
  children: React.ReactNode;
  productTitle?: string;
};
export const PageLoaderLayout = ({
  children,
  footer,
  productTitle,
}: PageLoaderLayoutProps) => {
  return (
    <FullPageLayout
      footer={footer}
      header={<PageLoaderHeader productTitle={productTitle ?? ''} />}
    >
      {children}
    </FullPageLayout>
  );
};
